import "./App.css";
import logo from "./logo.png";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary defaultKeyword="incense" />
        </main>
        <footer className="App-footer">
          This project was coded by{" "}
          <a
            href="https://pensive-goldwasser-b5f98d.netlify.app/index.html"
            target="_blank"
            rel="noreferrer"
          >
            Deya Shrestha
          </a>{" "}
          and is open-sourced on{" "}
          <a
            href="https://github.com/DeyaSHTA93/dictionary-project"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>{" "}
          and hosted on{" "}
          <a
            href="https://stupefied-mccarthy-6bb50e.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            Netlify
          </a>
          .
        </footer>
      </div>
    </div>
  );
}
